import React, { useState, useEffect } from 'react';
import Logoimg from '../../assets/img/logo.png';
import { LockOutlined, UserOutlined, MobileOutlined } from '@ant-design/icons';
import { Button, Form, Input, Row, Col } from 'antd';
import axios from "axios";
import { toast } from "react-toastify";
import Swal from 'sweetalert2';
import { ToastContainer } from "react-toastify";
import withReactContent from 'sweetalert2-react-content';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';
// import { MdOutlinePhoneIphone } from "react-icons/md";

export default function Register() {

  const [isShown, setIsShown] = useState("false")
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [mobile, setMobile] = useState('');
  const [refercode, setRefercode] = useState('');
  const [refercode1, setRefercode1] = useState('');
  const [otp, setOtp] = useState(null);
  const [devid, SeTdevid] = useState('');
  // alert(devid)
  const navigate = useNavigate();
  // const [otpnumbers, otpnumber] = useState();
  const onFinish = (values) => {
    console.log('Received values of form: ', values);
  };
  var token = localStorage.getItem("userid");
  const [browserId, setBrowserId] = useState('');
  var refCodeeee = localStorage.getItem("refCodeeee");

  if (refCodeeee) {
  // Set a timeout to remove the item after 5 minutes (5 * 60 * 1000 ms)
  setTimeout(() => {
    localStorage.removeItem("refCodeeee");
    console.log("refCodeeee cleared after 5 minutes");
  }, 5 * 60 * 1000);
}

  useEffect(() => {

    const queryParameters = new URLSearchParams(window.location.search);
    const reffercode = queryParameters.get("reffercode");
    // alert(reffercode)
    setRefercode1(reffercode);
    let browserIdd = Cookies.get('browserId');
    //  alert(browserIdd)
    if (!browserIdd) {
      browserIdd = uuidv4();
      Cookies.set('browserId', browserIdd, { expires: 365 }); // Store the ID in a cookie that expires in 365 days
    }
    localStorage.setItem("dev_id", browserIdd);
    setBrowserId(browserIdd)


    // alert(setBrowserId);
    // console.log('Browser ID:', browserIdd);
  }, []);

  // useEffect(() => {
  //  if(token){
  //   window.location.href = '/Home';
  //  }
  // }, [])

  // const dev_id = localStorage.getItem("dev_id");
  const onInputChangename = (e) => {
    setName(e.target.value);
  };

  const onInputChangepassword = (e) => {
    setPassword(e.target.value);
  };

  const onInputChangemobile = (e) => {
    setMobile(e.target.value);
  };


  const [alternate_mobile, setAlternateMobile] = useState('');

  const handleChange = (e) => {
    let inputValue = e.target.value;
    // Remove any non-digit characters
    inputValue = inputValue.replace(/\D/g, '');
    setAlternateMobile(inputValue);
  };
  // const onInputChangerefercode = (e) => {
  //   setRefercode(e.target.value);
  // };
  const onInputChangerefercode = (newValue) => {
    setRefercode1(newValue);
  };

  const onInputChangeotp = (e) => {
    setOtp(e.target.value);
  };

  // const navigate = useNavigate();

  const Registerotp = async () => {
    try {
      const requestData = {
        name: name,
        pss: password,
        mobileNum: alternate_mobile,
        otp: otp,
        refercode: refercode1 || refCodeeee,
        dev_id: browserId,
        app_id: process.env.REACT_APP_API_ID
      };

      // const response = await fetch(`https://nodeapi.khelogalifaridabad.com/api/users/register`, {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/register`, {

        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestData),
      });

      // Parse the response to JSON
      const data = await response.json();
      console.log("API Response:", data);

      if (data.success == 1) {  // Corrected response handling
        setIsShown(true);
        SeTdevid(true);

        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'User registered successfully!.',
          timer: 2000
        }).then(() => {
          navigate('/');
          localStorage.setItem("userid", data.user_id);
          sessionStorage.setItem("user_id", data.user_id);
          localStorage.setItem('login_token', data.auth);
              localStorage.removeItem("refCodeeee");

        });

      } else if (data.success == 0) {
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: data.message || 'An error occurred!',
          timer: 2000
        });
      } else if (data.success == 3) {
        Swal.fire({
          icon: 'warning',
          title: 'Invalid OTP',
          text: data.message || 'The OTP you entered is incorrect.',
          timer: 2000
        });
      }

    } catch (error) {
      console.error('Error in Registerotp:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Something went wrong. Please try again later.',
        timer: 2000
      });
    }
  };

  const Sendotp = async () => {

    if (!name) {

      toast.error('Please enter a valid name address.');
      return;
    }
    // if (!refercode ) {

    //   toast.error('Please enter a valid refercode address.');
    //   return;
    // }

    if (!password || password.length < 6) {

      toast.error('Password must be at least 6 characters long.');
      return;
    }
    // if (!mobile || mobile.length < 10) {

    //   toast.error('Password must be at least 10 characters long.');
    //   return;
    // }
    // setLoading(true);
    try {
      const requestData = {
        name: name,
        pss: password,
        mobileNum: alternate_mobile,
        // refercode: refercode1, // Uncomment करें अगर ज़रूरत हो
        lat: "fdfd",
        lng: "fdfdf",
        dev_id: browserId,
        app_id: process.env.REACT_APP_API_ID
      };

      // const response = await fetch(`https://nodeapi.khelogalifaridabad.com/api/users/register-step1`, {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/register-step1`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();
      console.warn("data", data.success)


      if (data.success == 1) { // ✅ अब सही तुलना हो रही है
        setIsShown(true);
        // devid(true);

        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: data.message, // ✅ API का सही message दिखाएगा
          timer: 2000
        }).then(() => {
          // localStorage.setItem('dev_id', data.device_id);
          sessionStorage.setItem('devid', data.device_id);
          console.warn("Device ID:", data.device_id);
          // window.location.href = '/Home';
        });


      } else if (data.success === 0) { // ✅ तुलना सही की गई
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: data.message, // ✅ API error message दिखाएगा
          timer: 2000
        });
      }


    } catch (error) {
      console.error('User Name Update Error:', error);
      console.error('An error occurred while updating username. Please try again later.');
      // setIsShown(false);
    }

  }







  return (
    <>
      <section id="Register">
        <div className="register">
          <Row justify={'center'}>
            <Col xs={24} xl={8}>
              <div className="logo w-100 text-center">
                <img src={Logoimg} className="img-fluid" alt="Logo" style={{ width: "150px" }} />
              </div>

              <div className="formregister text-transform-uppercase">
                <Form
                  name="normal_login"
                  className=""
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                >
                  <Form.Item
                    name="name "
                    className='text-transform-uppercase'

                    rules={[
                      {
                        required: true,
                        message: 'Please input your Name!',
                      },
                    ]}
                  >
                    <Input

                      prefix={<UserOutlined className="site-form-item-icon " />}
                      placeholder="Name"
                      className='text-transform-uppercase'
                      style={{ textTransform: 'uppercase' }}
                      value={name}
                      onChange={onInputChangename}
                    />
                  </Form.Item>
                  {/* <Form.Item
                    name="Mobile"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your Mobile number!',
                      },
                    ]}
                  >
                    <Input
                      prefix={<MobileOutlined className="site-form-item-icon" />}
                      type="text"
                      placeholder="Mobile Number"
                      value={mobile}
                      onChange={onInputChangemobile}
                    />

                   
                  </Form.Item> */}



                  <Form.Item
                    name="Mobile Number"

                  >
                    <Input

                      prefix={<MobileOutlined className="site-form-item-icon" />}
                      showCount maxLength={10} id="Alternativemobilenumber"
                      value={alternate_mobile}
                      onChange={handleChange}
                      type='tel'
                      // onKeyDown={(e) => {

                      //   if (e.key === 'Backspace') {
                      //     return;
                      //   }

                      //   if (/^[0-9]$/.test(e.key)) {
                      //     return;
                      //   }

                      //   e.preventDefault();
                      // }}
                      // onKeyPress={(e) => {

                      //   if (!/^[0-9]$/.test(e.key) && e.key !== 'Backspace') {
                      //     e.preventDefault();
                      //   }
                      // }}
                      placeholder=" Mobile Number" />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: 'Please input your Password!',
                      },
                    ]}
                  >
                    <Input
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={onInputChangepassword}
                    />
                  </Form.Item>

                  <Form.Item
                    name="Refer"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please input your Refer Code!',
                  //   },
                  // ]}
                  >
                    {refercode}
                    <Input
                      prefix={<MobileOutlined className="site-form-item-icon" />}
                      type="text"
                      placeholder="Refer Code"
                      value={refercode1 || refCodeeee}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        onInputChangerefercode(newValue);

                        // Check if a new value is entered and clear accountno
                        if (newValue !== refercode1) {
                          setRefercode('');
                        }
                      }}
                    />

                  </Form.Item>
                  {isShown == true ? (
                    <Col span={24} xl={24} md={24}>
                      <Form.Item
                        name="otp"
                        rules={[
                          {
                            required: true,
                            message: 'Please input your OTP!',
                          },
                        ]}
                      >

                        <Input style={{ padding: "9px" }} onChange={onInputChangeotp} placeholder="Enter OTP" />

                      </Form.Item>
                    </Col>
                  ) : null}



                  <Form.Item>
                    {isShown == true ? <button type="button" onClick={Registerotp} className="bg-green w-100 btn refer-button cxy  otp_login submit_data" id="submit_data" name="submit_data" >Register</button> : <button type="submit" className="w-100 btn  text-white bg-green refer-button cxy mt-4 send-otp" id="send_ottp" onClick={Sendotp}>Send OTP</button>}
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
